import { render, staticRenderFns } from "./section-linea-servicios.vue?vue&type=template&id=18bc29c6&scoped=true"
import script from "./section-linea-servicios.vue?vue&type=script&lang=js"
export * from "./section-linea-servicios.vue?vue&type=script&lang=js"
import style0 from "./section-linea-servicios.vue?vue&type=style&index=0&id=18bc29c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc29c6",
  null
  
)

export default component.exports